module.exports = {"local":{"interval":[0,151]},"mulher-aparece":{"interval":[152,226]},"caminhando":{"interval":[235,340],"loop":true},"aceno":{"interval":[341,471],"loop":false},"renda":{"interval":[475,605]},"escolaridade":{"interval":[607,737]},"trabalho":{"interval":[739,869]},"crush":{"interval":[871,1002]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/anims.json
// module id = GAQX
// module chunks = 0